@if (showAlertConfirmaPedido === true) {
  <div class="body-alert">
    <div class="div-alert text-center">
      <img class="mt-5" src="/assets/img/fazer-pedido.png" width="102px" alt="Conclusao de pedido">
      <p class="titulo-alert"> Deseja concluir esse pedido? </p>
      <p class="subtitulo-alert"> Conclua e vá para o resumo do pedido ou clique em cancelar </p>
      <button class="botao mt-3 mb-3 me-2 text-nowrap" id="btnConcluirPedido" (click)=" onConfirmarPedido() "
        [tag]="addTagManagerInteraction('box:button:click', 'concluir-pedido')"
      >CONCLUIR PEDIDO</button>
      <button type="button" class="botao-outline" id="btnCancelarPedido" (click)="onFecharConcluirPedido()"
        [tag]="addTagManagerInteraction('box:button:click', 'cancelar')"
      >CANCELAR</button>
    </div>
  </div>
}
